import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e?.preventDefault();
    if (email) {
      setSubscribed(true);
      setTimeout(() => {
        setEmail('');
        setSubscribed(false);
      }, 3000);
    }
  };

  const footerLinks = {
    destinations: [
      { label: 'Boracay', path: '#' },
      { label: 'El Nido', path: '#' },
      { label: 'Siargao', path: '#' },
      { label: 'Palawan', path: '#' },
      { label: 'Cebu', path: '#' }
    ],
    company: [
      { label: 'About Us', path: '#' },
      { label: 'Our Partners', path: '#' },
      { label: 'Careers', path: '#' },
      { label: 'Press', path: '#' },
      { label: 'Blog', path: '#' }
    ],
    support: [
      { label: 'Help Center', path: '#' },
      { label: 'Safety Guidelines', path: '#' },
      { label: 'Cancellation Policy', path: '#' },
      { label: 'Contact Us', path: '#' },
      { label: 'FAQs', path: '#' }
    ],
    legal: [
      { label: 'Privacy Policy', path: '#' },
      { label: 'Terms of Service', path: '#' },
      { label: 'Cookie Policy', path: '#' },
      { label: 'Accessibility', path: '#' }
    ]
  };

  const socialLinks = [
    { icon: 'Facebook', label: 'Facebook', url: '#' },
    { icon: 'Instagram', label: 'Instagram', url: '#' },
    { icon: 'Twitter', label: 'Twitter', url: '#' },
    { icon: 'Youtube', label: 'YouTube', url: '#' }
  ];

  return (
    <footer className="border-t border-border bg-[rgba(5,102,102,1)]">
      {/* Newsletter Section - Compact */}
      <div className="border-b border-border bg-teal-50">
        <div className="max-w-[1200px] mx-auto px-2 md:px-3 py-1 md:py-1.5">
          <div className="flex flex-col md:flex-row gap-1 items-center justify-between">
            <div className="flex-1">
              <h3 className="md:text-[6.8px] font-bold mb-0 text-[rgba(49,45,43,1)] text-[10px]">
                Stay Updated on Philippine Adventures
              </h3>
              <p className="text-[5.1px] md:text-[6px] text-[rgba(29,29,32,1)] hidden md:block">
                Get exclusive deals and travel tips
              </p>
            </div>
            <form onSubmit={handleSubscribe} className="flex gap-0.5 w-full md:w-auto">
              <Input
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e?.target?.value)}
                required
                className="flex-1 md:w-40 text-[6px] h-5 px-1.5 py-0.5"
              />
              <Button
                type="submit"
                variant="default"
                size="default"
                iconName={subscribed ? 'Check' : 'Send'}
                iconPosition="right"
                disabled={subscribed}
                className="px-1.5 py-0.5 h-5 text-[10px]"
              >
                {subscribed ? 'Subscribed!' : 'Subscribe'}
              </Button>
            </form>
          </div>
        </div>
      </div>

      {/* Main Footer Content - Compact */}
      <div className="max-w-[1200px] mx-auto px-2 md:px-3 py-1.5 md:py-2 bg-[rgba(4,103,100,0.902)]">
        {/* Brand Section - Compact */}
        <div className="mb-1.5">
          <div className="flex items-center gap-0.5 mb-0.5">
            <div className="w-4 h-4 rounded-lg flex items-center justify-center bg-gradient-to-br from-primary to-secondary">
              <Icon name="Palmtree" size={8} color="#FFFFFF" />
            </div>
            <span className="text-orange-300 font-bold text-[11.9px]">
              LetsTravel Philippines
            </span>
          </div>
          <p className="mb-0.5 max-w-2xl text-[rgba(252,252,253,1)] text-[11.9px]">
            Your trusted companion for discovering the Philippines
          </p>
          
          {/* Social Links - Compact */}
          <div className="flex items-center gap-0.5 mb-1">
            {socialLinks?.map((social, index) => (
              <a
                key={index}
                href={social?.url}
                className="w-3.5 h-3.5 rounded-lg bg-muted hover:bg-primary hover:text-primary-foreground flex items-center justify-center transition-all duration-300"
                aria-label={social?.label}
              >
                <Icon name={social?.icon} size={7} />
              </a>
            ))}
          </div>
        </div>

        {/* Multi-Column Links Section - Compact 4 Columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-1.5 mb-1.5">
          {/* Column 1: Destinations */}
          <div>
            <h4 className="font-semibold mb-0.5 text-orange-300 text-[10px]">Destinations</h4>
            <ul className="space-y-0">
              {footerLinks?.destinations?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.path}
                    className="hover:text-primary transition-colors duration-300 text-white block text-[10px] font-light"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 2: Company */}
          <div>
            <h4 className="font-semibold mb-0.5 text-orange-300 text-[10px]">Company</h4>
            <ul className="space-y-0">
              {footerLinks?.company?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.path}
                    className="hover:text-primary transition-colors duration-300 text-white block text-[10px]"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Support */}
          <div>
            <h4 className="font-semibold mb-0.5 text-orange-300 text-[10px]">Support</h4>
            <ul className="space-y-0">
              {footerLinks?.support?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.path}
                    className="hover:text-primary transition-colors duration-300 text-white block text-[10px]"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Legal */}
          <div>
            <h4 className="font-semibold mb-0.5 text-orange-300 text-[10px]">Legal</h4>
            <ul className="space-y-0">
              {footerLinks?.legal?.map((link, index) => (
                <li key={index}>
                  <a
                    href={link?.path}
                    className="hover:text-primary transition-colors duration-300 text-white block text-[10px]"
                  >
                    {link?.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Info - Single Row 3 Columns - Compact */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-1 p-0.5 bg-muted rounded mb-1">
          <div className="flex items-center gap-0.5">
            <div className="w-3 h-3 rounded bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Mail" size={7} color="var(--color-primary)" />
            </div>
            <div className="min-w-0">
              <p className="text-[5.1px] font-semibold text-foreground mb-0 leading-tight">Email</p>
              <a
                href="mailto:support@letstravelph.com"
                className="text-[4.25px] text-muted-foreground hover:text-primary transition-colors duration-300 break-words leading-tight"
              >
                support@letstravelph.com
              </a>
            </div>
          </div>

          <div className="flex items-center gap-0.5">
            <div className="w-3 h-3 rounded bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Phone" size={7} color="var(--color-primary)" />
            </div>
            <div className="min-w-0">
              <p className="text-[5.1px] font-semibold text-foreground mb-0 leading-tight">Call</p>
              <a
                href="tel:+63281234567"
                className="text-[4.25px] text-muted-foreground hover:text-primary transition-colors duration-300 break-words leading-tight"
              >
                +63 (2) 8123-4567
              </a>
            </div>
          </div>

          <div className="flex items-center gap-0.5">
            <div className="w-3 h-3 rounded bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="MapPin" size={7} color="var(--color-primary)" />
            </div>
            <div className="min-w-0">
              <p className="text-[5.1px] font-semibold text-foreground mb-0 leading-tight">Visit</p>
              <p className="text-[4.25px] text-muted-foreground break-words leading-tight">
                Makati City, Metro Manila
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar - Compact */}
        <div className="pt-0.5 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between gap-0.5">
            <p className="text-[5.1px] text-center md:text-left text-[rgba(252,252,253,1)]">
              © {new Date()?.getFullYear()} LetsTravel Philippines. All rights reserved.
            </p>
            <div className="flex items-center gap-1.5">
              <div className="flex items-center gap-0.5">
                <Icon name="Shield" size={7} color="var(--color-success)" />
                <span className="text-[5.1px] text-[rgba(252,252,252,1)]">Secure Payments</span>
              </div>
              <div className="flex items-center gap-0.5">
                <Icon name="Award" size={7} color="var(--color-success)" />
                <span className="text-[5.1px] text-neutral-50">DOT Certified</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;